import { RouteDifficulty } from "griptonite-api-client";

const estimateDifficultyMap = {
  [-1]: 0.1,
  [0]: 0.4,
  [1]: 0.7,
  [2]: 1,
};

const estimateGrade = (grades: string[], difficulty: RouteDifficulty | null): string | null => {
  if (grades.length && difficulty !== null) {
    return (
      grades[Math.max(0, Math.round(grades.length * estimateDifficultyMap[difficulty] - 1))] || ""
    );
  }

  return null;
};

export default estimateGrade;
